<template>
  <section v-editable="blok" :class="getComponentClass(blok)">
    <div class="news-insights__container container">
      <div v-if="blok.title || !blok.disableLink" class="row">
        <h3 v-if="blok.title" class="news-insights__title col-12">
          {{ blok.title }}
        </h3>
        <component
          :is="'a-link' | dashify"
          v-if="!blok.disableLink"
          ref="link"
          :blok="getLinkConfig()"
          modifier-class="icon icon--arrow col-12 news-insights__main-link"
        />
      </div>

      <div v-if="newsinsights.length" class="news-insights__body row">
        <div
          v-for="newsinsight in newsinsights"
          :key="newsinsight.id"
          class="col-12 col-sm-6 col-lg-3 news-insights__thumbnail-wrapper"
        >
          <component
            :is="'m-thumbnail' | dashify"
            :blok="getThumbnailConfig(newsinsight)"
          />
        </div>
      </div>

      <div v-if="!newsinsights.length" class="news-insights__empty row">
        <div class="col-12">Sorry, there are no results.</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsInsights',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    datas: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {
      newsinsights: [],
    }
  },
  watch: {
    datas() {
      this.newsinsights = this.datas
    },
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
      }
    },
  },
  mounted() {
    if (this.requestData) {
      this.$storyapi
        .get('cdn/stories', {
          starts_with: (this.blok || {}).api || 'latest/',
          is_startpage: '0',
          cv: this.$store.state.cacheVersion,
          version: 'draft',
        })
        .then((res) => {
          if (this.blok.limit) {
            this.newsinsights = res.data.stories.slice(0, this.blok.limit)
          } else {
            this.newsinsights = res.data.stories
          }
        })
        .catch((res) => {
          // eslint-disable-next-line no-console
          console.error('News Insights - Failed to load resource', res)
        })
    }
  },
  methods: {
    getComponentClass(blok) {
      const shadow = blok.hasShadow ? ' news-insights--shadow' : ''
      const height = blok.isHScreen ? ' h-screen' : 'h-default'
      return `theme-gray-light news-insights ${shadow} ${height}`
    },
    getThumbnailConfig: (config) => {
      return {
        variation: 'news',
        image: config.content.image,
        date: config.content.date,
        title: config.content.title,
        link: `/${config.full_slug}`,
      }
    },
    getLinkConfig() {
      return {
        text: 'View all articles',
        link: {
          url: '/thinking',
        },
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.news-insights {
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.h-default {
    min-height: 300px;
  }

  &--shadow {
    overflow: hidden;
    &::before {
      @extend %block-shadow;
    }
  }

  &__container {
    height: 100%;
  }

  .section-header {
    margin-bottom: spacer(2);
  }

  .icon--arrow {
    &::before {
      @include font-size(10);

      margin-right: 10px;
    }
  }
}

.news-insights__title {
  @include font-family($font-family-headings-bold, $headings-font-weight);
  @include font-size(36);

  margin-top: 0;
  margin-bottom: spacer(1);
}

.news-insights__title:hover {
  border: 2px solid red;
}

.news-insights__main-link {
  display: block;
  margin-bottom: spacer(2);
}

.news-insights__thumbnail-wrapper {
  margin: 0 0 60px;
}

.news-insights__empty {
  padding-top: spacer(1);
  padding-bottom: spacer(1);
}

@include media-breakpoint-up(lg) {
  .news-insights {
    padding: 0 0 50px;

    .section-header {
      margin-bottom: spacer(6);
    }
  }

  .news-insights__empty {
    padding-top: spacer(7);
  }
}
</style>
